import { Translation } from '@ps/web-shared-components';
import { differenceInMinutes } from 'date-fns';
import React from 'react';

import { FormattedUTCDate } from '@swf/poker';

import { TXTCLI_In_N0_min, TXTCLI_Now } from './StartTime.messages.json';

interface Props {
  startDateTime?: string;
}

const StartTime: React.FC<Props> = ({ startDateTime }) => {
  if (!startDateTime) return null;

  const date = new Date(startDateTime);
  const now = new Date();
  const diff = differenceInMinutes(date, now);

  if (diff === 0) {
    return <Translation {...TXTCLI_Now} />;
  }

  if (diff > 0 && diff <= 60) {
    return <Translation {...TXTCLI_In_N0_min} values={{ 0: diff }} />;
  }

  return (
    <FormattedUTCDate
      utcDate={startDateTime}
      options={{ dateStyle: 'medium', timeStyle: 'short' }}
    />
  );
};

export default StartTime;
